import { buildApiUrl } from "../config/endpoints";

// Engine timestamps are UTC (DB column is TIMESTAMP WITHOUT TIME ZONE, RDS is UTC).
// Convert to epoch ms so the table can apply the SGT timeZone option consistently.
const toEpochMs = (raw) => {
    if (raw == null || raw === "") return null;
    if (typeof raw === "number") return raw;
    const s = String(raw).trim();
    if (/^\d+$/.test(s)) return parseInt(s, 10);
    if (/(?:Z|[+-]\d{2}:?\d{2})$/.test(s)) return Date.parse(s);
    // Naive timestamp — treat as UTC by appending Z.
    return Date.parse(s.replace(" ", "T") + "Z");
};

// Normalize engine snake_case fields to the GraphQL-shaped keys the tables expect.
const normalizeOrder = (item) => {
    const created = toEpochMs(item.created_at || item.createdat);
    const updated = toEpochMs(item.updated_at || item.updatedat);
    const filled = toEpochMs(item.filled_at || item.filledat);
    return {
        ...item,
        buyside: item.buyside || item.side || item.action,
        ordertype: item.ordertype || item.order_type || item.type,
        quantity: item.quantity ?? item.qty,
        price: item.price,
        fillprice: item.fillprice ?? item.fill_price,
        createdat: created,
        updatedat: updated,
        filledat: filled,
        created_at: created,
        updated_at: updated,
        filled_at: filled,
    };
};

export const getOrderHandler = async (owner, symbol, setAsks, setBids, setClosed) => {
    try {
        const response = await fetch(buildApiUrl('/order') + '?' + new URLSearchParams({ symbol: symbol, owner_id: owner }));
        if (!response.ok) {
            throw new Error(`Error! status: ${response.status}`);
        }
        const result = await response.json();
        setAsks((result.asks || []).map(normalizeOrder));
        setBids((result.bids || []).map(normalizeOrder));
        setClosed((result.closed || []).map(normalizeOrder));
    } catch (err) {
        return err
    }
}